<header class:loggedIn={isLoggedIn}>
  <div class="header-container upper">
    <div class="header-content">
      <Components.Node name='header-upper-left' class="header-upper__left" shared />
      <Components.Node name='header-upper-right' class="header-upper__right" shared />
    </div>
  </div>
  <div class="header-container lower">
    <div class="header-content">
      <Components.Node name='header-lower-middle' class="header-lower__middle" shared />
    </div>
  </div>
</header>

<main class='main-content'>
  <Components.Node name='main-content' customisable layoutsAboveFold={2}/>
</main>

<Components.Fold />

<footer>
  <div class="footer-content">
    <div class="footer-row row-1">
      <Components.Node name="footer-row-1-col-1" shared/>
    </div>
    <div class="footer-row row-2">
      <Components.Node name="footer-row-2-col-1" class="no-p-margin"shared/>
      <Components.Node name="footer-row-2-col-2" shared/>
      <Components.Node name="footer-row-2-col-3" shared/>
      <Components.Node name="footer-row-2-col-4" shared/>
      <Components.Node name="footer-row-2-col-5" shared/>
    </div>
    <div class="footer-row row-3">
      <Components.Node name="footer-row-3-col-1" shared/>
    </div>
    <div class="footer-row row-4">
      <Components.Node name="footer-row-4-col-1" shared/>
      <Components.Node name="footer-row-4-col-2" shared/>
      <Components.Node name="footer-row-4-col-3" shared/>
    </div>
  </div>
</footer>

<svelte:head>
  {#if !custom?.user?.useCustomStylesheet}
    <link rel="stylesheet" href="/components/{meta.ref}.client.css">
  {:else}
    <link rel="stylesheet" href={`https://${platform.router.host}/${customStylePath}`}>
  {/if}
  {#if contentWidthStyle}
    {@html contentWidthStyle}
  {/if}
</svelte:head>

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  import presetLayouts from './presetLayouts.json'

  export const presets = presetLayouts

  export const meta = {
    css: false,
  }
  export const classNames = ['base-template']
  export const Components = {
    load: [
      'core/extensions/layout/v2.0.0/Node',
      'core/extensions/layout/v2.0.0/Fold',
    ],
  }

  export { layouts } from './layouts.js'

  export const options = [
    {
      type: 'switch',
      key: 'useCustomStylesheet',
      label: 'Use Custom Stylesheet (in files/stylesheets/custom.css)',
    },
    {
      type: 'number',
      key: 'contentWidth',
      label: 'Main content width (px)',
    },
  ]

</script>

<script>
  import './style.scss'
  import { onMount, getContext } from 'svelte'

  export let custom = {}

  const customStyleName = 'custom.css'
  const customStylePath = `files/stylesheets/${customStyleName}`

  const contentWidthStyle = `
    <style>
      :root {
        --content-width: ${custom?.user?.contentWidth || 1440}px;
      }
    
</style>
  `

  const platform = getContext('platform')
  const isLoggedIn = platform.api.core.isLoggedIn()

  onMount(async () => {
    let needsReload = false
    if (custom?.user?.useCustomStylesheet) {
      const existingCustomStyle = await fetch(`https://${platform.router.host}/${customStylePath}`)

      if (existingCustomStyle.status === 200) {
        return
      }

      const style = await fetch(`/components/${meta.ref}.client.css`)
      await platform.api.cms.files.upload([new File([await style.text()], customStyleName)], 'files/stylesheets')
      needsReload = true
    }

    if (needsReload) {
      window.location.reload()
    }
  })
</script>

<style lang="scss">:global(header) {
  position: sticky;
  top: 0px;
  z-index: 15;
  font-weight: bold;
}
:global(header.loggedIn) {
  top: 49px;
}
:global(header) :global(.dropdown) {
  background: var(--cream);
}
:global(header) :global(.dropdown::after) {
  background: var(--cream);
  width: calc(100vw - var(--content-width) / 2);
}
:global(header) :global(.dropdown::before) {
  background-color: var(--cream);
  width: calc(100vw - var(--content-width) / 2);
}
:global(.header-container) {
  width: 100%;
  display: flex;
  justify-content: center;
}
:global(.header-container) :global(.header-container) {
  width: 100%;
  display: flex;
  justify-content: center;
}
:global(.header-container) :global(.header-content) {
  width: 100%;
  max-width: var(--content-width);
  display: flex;
  height: 90px;
  align-items: center;
  padding: 0 1rem;
}
:global(.header-container.upper) :global(.header-content) {
  justify-content: space-between;
}
@media screen and (min-width: 1440px) {
  :global(.header-container.upper) :global([data-plugin-ref="consultus/plugins/menu/v1.0.0/Menu"]) {
    display: none !important;
  }
}
@media screen and (max-width: 1440px) {
  :global(.header-container.upper) :global([data-plugin-ref="core/plugins/html/v1.0.0/Html"]) {
    display: none !important;
  }
}
:global(.header-container.lower) {
  background-color: var(--light-pink);
}
@media screen and (max-width: 1440px) {
  :global(.header-container.lower) {
    display: none;
  }
}
:global(.header-container.lower) :global(.node-element) {
  width: 100%;
}
:global(.header-container.lower) :global(.header-content) {
  justify-content: center;
}
:global(footer) {
  padding: 2rem 1rem;
}
:global(footer) :global(a) {
  font-weight: bold;
  text-decoration: none;
}
:global(footer) :global(.no-p-margin) :global(p) {
  margin: 0;
}
:global(.footer-content) {
  width: 100%;
  max-width: var(--content-width);
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
:global(.footer-row) {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
:global(.footer-row.row-4) {
  align-items: center;
  font-size: 16px;
}
:global(.footer-row.row-4) :global(a) {
  font-weight: normal;
}
:global(.layout-row) {
  gap: 20px;
  width: 100%;
  margin: auto;
  justify-content: center;
  max-width: var(--content-width);
  padding-left: 1rem;
  padding-right: 1rem;
}
:global(.layout-row.full-width) {
  max-width: 100%;
}
@media (max-width: 650px) {
  :global(.layout-row) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
:global(.single-column) {
  display: flex;
  justify-content: center;
  max-width: 960px;
}
@media screen and (max-width: 650px) {
  :global(.layout-column) {
    padding: 1rem;
  }
}
:global(.single-column) :global(.layout-column) {
  width: 100%;
  max-width: 960px;
}
:global(.single-column-double-width) {
  display: flex;
  justify-content: center;
  max-width: var(--content-width);
}
:global(.single-column-double-width) :global(.layout-column) {
  width: 100%;
  max-width: var(--content-width);
}
:global(.two-columns) {
  display: flex;
  gap: 40px;
}
@media screen and (max-width: 1000px) {
  :global(.two-columns) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
:global(.two-columns) :global(.layout-column) {
  width: 50%;
  max-width: calc(var(--content-width) / 2 - 20px);
}
@media (max-width: 1000px) {
  :global(.two-columns) :global(.layout-column) {
    width: 100%;
    max-width: calc(var(--content-width) / 2);
  }
}
:global(.three-columns) {
  display: flex;
  gap: 40px;
}
@media screen and (max-width: 1000px) {
  :global(.three-columns) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
:global(.three-columns) :global(.layout-column) {
  width: 33.3333333333%;
  max-width: calc(var(--content-width) / 3 - 26.6666666667px);
}
@media (max-width: 1000px) {
  :global(.three-columns) :global(.layout-column) {
    width: 100%;
    max-width: calc(var(--content-width) / 3);
  }
}
:global(.quarter-half-quarter) {
  display: flex;
  gap: 40px;
}
:global(.quarter-half-quarter) :global(.layout-column.col-25) {
  width: 25%;
  max-width: calc(var(--content-width) / 4 - 30px);
}
:global(.quarter-half-quarter) :global(.layout-column.col-50) {
  width: 50%;
  max-width: calc(var(--content-width) / 2 - 20px);
}
@media (max-width: 1000px) {
  :global(.quarter-half-quarter) {
    flex-wrap: wrap;
    gap: 20px;
  }
  :global(.quarter-half-quarter) :global(.layout-column.col-25),
:global(.quarter-half-quarter) :global(.layout-column.col-50) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.quarter-quarter-half) {
  display: flex;
  gap: 40px;
}
:global(.quarter-quarter-half) :global(.layout-column.col-25) {
  width: 25%;
  max-width: calc(var(--content-width) / 4 - 30px);
}
:global(.quarter-quarter-half) :global(.layout-column.col-50) {
  width: 50%;
  max-width: calc(var(--content-width) / 2 - 20px);
}
@media (max-width: 1000px) {
  :global(.quarter-quarter-half) {
    flex-wrap: wrap;
    gap: 20px;
  }
  :global(.quarter-quarter-half) :global(.layout-column.col-25),
:global(.quarter-quarter-half) :global(.layout-column.col-50) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.forty-twenty-twenty-twenty) {
  display: flex;
  gap: 40px;
}
:global(.forty-twenty-twenty-twenty) :global(.layout-column.col-20) {
  width: 20%;
  max-width: calc(var(--content-width) / 5 - 40px);
}
:global(.forty-twenty-twenty-twenty) :global(.layout-column.col-40) {
  width: 40%;
  max-width: calc(var(--content-width) / 100 * 40 - 20px);
}
@media (max-width: 1000px) {
  :global(.forty-twenty-twenty-twenty) {
    flex-wrap: wrap;
    gap: 20px;
  }
  :global(.forty-twenty-twenty-twenty) :global(.layout-column.col-20),
:global(.forty-twenty-twenty-twenty) :global(.layout-column.col-40) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.four-columns) {
  display: flex;
  gap: 40px;
}
@media screen and (max-width: 1000px) {
  :global(.four-columns) {
    flex-wrap: wrap;
  }
}
:global(.four-columns) :global(.layout-column) {
  width: 25%;
  max-width: calc(var(--content-width) / 4 - 30px);
}
@media (max-width: 1000px) {
  :global(.four-columns) :global(.layout-column) {
    max-width: calc(50% - 20px);
    width: calc(50% - 20px);
  }
}
@media (max-width: 650px) {
  :global(.four-columns) :global(.layout-column) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.sixty-forty),
:global(.forty-sixty) {
  display: flex;
  gap: 40px;
}
@media screen and (max-width: 650px) {
  :global(.sixty-forty),
:global(.forty-sixty) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
:global(.sixty-forty) :global(.col-40),
:global(.forty-sixty) :global(.col-40) {
  width: 40%;
  max-width: calc(var(--content-width) / 100 * 40 - 20px);
}
@media (max-width: 650px) {
  :global(.sixty-forty) :global(.col-40),
:global(.forty-sixty) :global(.col-40) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.sixty-forty) :global(.col-60),
:global(.forty-sixty) :global(.col-60) {
  width: 60%;
  max-width: calc(var(--content-width) / 100 * 60 - 20px);
}
@media (max-width: 650px) {
  :global(.sixty-forty) :global(.col-60),
:global(.forty-sixty) :global(.col-60) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.overlap-right) {
  display: flex;
  align-items: center;
  gap: 0px;
}
:global(.overlap-right) :global(.left-column) {
  width: calc(var(--content-width) * 0.6 - 60px);
}
:global(.overlap-right) :global(.right-column) {
  width: calc(var(--content-width) * 0.5 - 60px);
  position: relative;
  left: calc(var(--content-width) * -0.1);
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1019607843);
}
:global(.overlap-left) {
  display: flex;
  align-items: center;
  gap: 0px;
}
:global(.overlap-left) :global(.left-column) {
  width: calc(var(--content-width) * 0.5 - 60px);
  position: relative;
  left: calc(var(--content-width) * 0.1);
  z-index: 2;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1019607843);
}
:global(.overlap-left) :global(.right-column) {
  width: calc(var(--content-width) * 0.6 - 60px);
}
@media (max-width: 1000px) {
  :global(.overlap-left),
:global(.overlap-right) {
    flex-wrap: wrap;
  }
  :global(.overlap-left) :global(.left-column),
:global(.overlap-left) :global(.right-column),
:global(.overlap-right) :global(.left-column),
:global(.overlap-right) :global(.right-column) {
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
  }
}
@media (max-width: 1000px) {
  :global(.overlap-left) {
    flex-direction: column-reverse;
  }
}
:global(.thirty-seventy),
:global(.seventy-thirty) {
  display: flex;
  gap: 40px;
}
@media screen and (max-width: 650px) {
  :global(.thirty-seventy),
:global(.seventy-thirty) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
:global(.thirty-seventy) :global(.col-30),
:global(.seventy-thirty) :global(.col-30) {
  width: 30%;
  max-width: calc(var(--content-width) / 100 * 30 - 20px);
}
@media (max-width: 650px) {
  :global(.thirty-seventy) :global(.col-30),
:global(.seventy-thirty) :global(.col-30) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.thirty-seventy) :global(.col-70),
:global(.seventy-thirty) :global(.col-70) {
  width: 70%;
  max-width: calc(var(--content-width) / 100 * 70 - 20px);
}
@media (max-width: 650px) {
  :global(.thirty-seventy) :global(.col-70),
:global(.seventy-thirty) :global(.col-70) {
    width: 100%;
    max-width: var(--content-width);
  }
}
:global(.add-layouts) :global(.outside) {
  display: flex;
  flex-wrap: nowrap;
}
:global(.add-layouts) :global(.outside.overlap-right) {
  flex-wrap: nowrap;
}
:global(.add-layouts) :global(.outside.overlap-right) :global(.right-column) {
  left: -20px;
  height: fit-content;
  border: 0.25rem solid #fff;
}
:global(.add-layouts) :global(.outside.overlap-left) {
  flex-wrap: nowrap;
}
:global(.add-layouts) :global(.outside.overlap-left) :global(.left-column) {
  left: 20px;
  height: fit-content;
  border: 0.25rem solid #fff;
}
:global(.add-layouts) :global(.outside.single-column) :global(.layout-column) {
  width: 50%;
}
:global(.add-layouts) :global(.outside.double-width) :global(.layout-column) {
  width: 100%;
}
:global(.register-user__form),
:global(.reset-password-form) {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: inherit;
  max-width: 350px;
}
:global(.register-user__form) :global(.register-user__field),
:global(.register-user__form) :global(.cms-text-input),
:global(.reset-password-form) :global(.register-user__field),
:global(.reset-password-form) :global(.cms-text-input) {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
:global(.register-user__form) :global(input),
:global(.register-user__form) :global(select),
:global(.reset-password-form) :global(input),
:global(.reset-password-form) :global(select) {
  padding: 0.5em;
  font-size: inherit;
  border-radius: 5px;
  border: 1px solid #ccc;
}
:global(.register-user__form) :global(.register-form--btn),
:global(.reset-password-form) :global(.register-form--btn) {
  display: flex;
  justify-content: center;
}
:global(.register-user__form) :global(button),
:global(.reset-password-form) :global(button) {
  width: fit-content;
  padding: 10px 20px;
  border-radius: 5px;
  margin: auto;
  background-color: #000;
  transition: 0.3s;
  color: #fff;
  font-size: inherit;
  border: none;
  cursor: pointer;
}
:global(.register-user__form) :global(button:hover),
:global(.reset-password-form) :global(button:hover) {
  background-color: #4c4c4c;
}
:global(.login-button) {
  font-size: inherit;
  cursor: pointer;
}
:global(.login-button) :global(button) {
  padding: 0;
  display: block;
  border: none;
  background: none;
}
:global(.login-button) :global(svg) {
  fill: #000;
}
:global(.login-button) :global(.menu-dropdown) :global(a),
:global(.login-button) :global(.menu-dropdown) :global(span) {
  transition: 0.3s;
}
:global(.cms-login-form) {
  max-width: 350px;
  margin: auto;
}
:global(.cms-login-form) :global(form) {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: inherit;
}
:global(.cms-login-form) :global(label) {
  margin-bottom: 5px;
}
:global(.cms-login-form) :global(.cms-login--form_input) {
  display: flex;
  flex-direction: column;
}
:global(.cms-login-form) :global(.cms-login--form_input) :global(input) {
  padding: 0.5em;
  font-size: inherit;
  border-radius: 5px;
  border: 1px solid #ccc;
}
:global(.cms-login-form) :global(.cms-login-buttons) {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
:global(.cms-login-form) :global(.cms-logged-in) {
  font-size: inherit;
}
:global(.cms-login-form) :global(input[type=submit]),
:global(.cms-login-form) :global(button) {
  width: fit-content;
  padding: 10px 20px;
  border-radius: 5px;
  margin: auto;
  background-color: #000;
  transition: 0.3s;
  color: #fff;
  font-size: inherit;
}
:global(.cms-login-form) :global(input[type=submit]:hover),
:global(.cms-login-form) :global(button:hover) {
  background-color: #4c4c4c;
}</style>
